import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  FootContainer,
  FootContent,
  FooterSection,
  Link,
  LinkSection,
  LogosSection,
  LogosWrapper,
  SocialSection,
  SubFooter,
  SubFooterContainer,
} from './style';
import { Logo, Text } from '../../atoms';
import { Container } from '../../gridSystem';
import compose from '../../../utils/compose';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';
import Icon from '../../atoms/Icon';
import logoSisfor from '../../assets/img/logo_sisfor.png';

const Footer = ({ mediaIsPhone, footer, subFooter }) => {
  const navigate = useNavigate();

  const renderLink = ({ type, data, gt }, index) => {
    switch (type) {
      case 'page_link':
      case 'privacy_policy':
        return (
          <Text
            key={`page-link-${index}`}
            type="b4"
            onClick={() => navigate(data?.path)}
            className="footer-link"
            tag="button"
          >
            {gt && (
              <span className="gt" aria-hidden="true">
                &gt;&nbsp;&nbsp;
              </span>
            )}
            <span style={{ marginLeft: -1 }}>{data?.text}</span>
          </Text>
        );
      case 'text':
        return (
          <Text key={`text-${index}`} type="b4">
            {data}
          </Text>
        );
      case 'help_desk':
      case 'email':
        return (
          <Link key={`email-${index}`} href={`mailto:${data}`}>
            {data ?? ''}
          </Link>
        );
      case 'phone_number':
        return (
          <Link key={`number-${index}`} href={`tel:${data?.phone}`}>
            {data?.title}
          </Link>
        );

      case 'external_link':
      default:
        return (
          <Link key={`external-link-${index}`} href={data?.uri} target="_blank">
            <Text type="b4">
              {gt && (
                <span className="gt" aria-hidden="true">
                  &gt;&nbsp;&nbsp;
                </span>
              )}
              <span style={{ marginLeft: -1 }}>{data?.title}</span>
            </Text>
          </Link>
        );
    }
  };

  return (
    <FootContainer>
      <Container className="content-wrapper">
        <FootContent>
          {(footer || []).map((section, i) =>
            section?.data?.length > 0 ? (
              <FooterSection
                key={`section-${section.title}-${i}`}
                className={section.type}
              >
                {section.type !== 'logo_carousel' ? (
                  section.type === 'contacts_carousel' ? (
                    <Text type="h3.5" mb={8} className="footer-title">
                      CONTATTI
                    </Text>
                  ) : (
                    <Text type="h3.5" mb={8} className="footer-title">
                      {section.title}
                    </Text>
                  )
                ) : null}
                {section.type === 'logo_carousel' && (
                  <LogosSection>
                    <Logo src={logoSisfor} alt="" />
                    {mediaIsPhone &&
                      section?.data?.map(({ data }, index) => (
                        <Logo
                          key={`logo-${index}`}
                          src={data?.logo?.src}
                          alt={data?.logo?.alt}
                        />
                      ))}
                  </LogosSection>
                )}
                {section.type === 'contacts_carousel' && (
                  <LinkSection className="contacts">
                    {section.data.map((item, index) => renderLink(item, index))}
                  </LinkSection>
                )}
                {section.type === 'link_carousel' && (
                  <LinkSection>
                    {section.data.map((item, index) =>
                      renderLink({ ...item, gt: true }, index)
                    )}
                  </LinkSection>
                )}
                {section.type === 'social_carousel' && (
                  <SocialSection>
                    {section.data.map(({ data }, si) => (
                      <a
                        key={`social-${si}-${data?.title}`}
                        href={data?.uri}
                        target="_blank"
                        aria-label="Social"
                      >
                        <Icon
                          type={`${data?.title?.toLowerCase()}`}
                          size={30}
                          strokeWidth={0.6}
                        />
                      </a>
                    ))}
                  </SocialSection>
                )}
              </FooterSection>
            ) : null
          )}
        </FootContent>
        {!mediaIsPhone && (
          <LogosWrapper>
            {footer
              .find((f) => f.type === 'logo_carousel')
              ?.data?.map(({ data }, index) => (
                <Logo
                  key={`logo-${index}`}
                  src={data?.logo?.src}
                  alt={data?.logo?.alt}
                />
              ))}
          </LogosWrapper>
        )}
      </Container>
      <SubFooter>
        <SubFooterContainer className="p-0">
          {(subFooter || []).map((link, i) => renderLink(link, `sub-${i}`))}
        </SubFooterContainer>
      </SubFooter>
    </FootContainer>
  );
};

Footer.propTypes = {
  mediaIsPhone: PropTypes.bool,
  footer: PropTypes.array,
  subFooter: PropTypes.array,
};

const composed = compose(
  connect((state) => {
    return {};
  }),
  withMediaQueries
)(Footer);
export default composed;
